import { useSearchParams } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import Pages from './components/Pages'
import Dialogs from './components/Dialogs/Dialogs'
import Error from './components/Error'
import { selectDialog } from './app/dialog'
import { useAppSelector, useInitialAppLoad } from './hooks'
import './index.css'

const App = () => {
  const [searchParams] = useSearchParams()
  const dialog = useAppSelector(selectDialog)
  const ErrorFallback = () => {
    return <Error />
  }

  const app = searchParams.get('app')
  const page = app === 'microsoft' ? 'Microsoft' : 'Google'
  useInitialAppLoad(page)
  return (
    <main>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Pages app={page} />
        {dialog && <Dialogs type={dialog} />}
      </ErrorBoundary>
    </main>
  )
}

export default App
